module.exports = __webpack_public_path__ + "static/media/elements_section2_slide3.f7f2f4f7.png";